module.exports = __webpack_public_path__ + "static/media/loading-thin-24-white.f352e91b.svg";